import { getUnreadMessageCount } from "../../services/InboxService";

export const SET_UNREAD_INBOX_MESSAGE_COUNT = "setUnreadInboxMessageCount";
export const SET_FEATURE_FLAG_EP = "SET_FEATURE_FLAG_EP";

export const setUnreadMessageCount = selectedPolicy => {
  return async dispatch => {
    let returnedData = await getUnreadMessageCount(
      selectedPolicy.MembershipNumber
    );
    dispatch({
      type: SET_UNREAD_INBOX_MESSAGE_COUNT,
      payload: { ...returnedData, LastRequestedTime: Date.now() }
    });
    dispatch({
      type: SET_FEATURE_FLAG_EP,
      payload: returnedData.enableEngagementPortal
    });

  };
};
